import React from "react";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { dt } from "../../../../shared/themes/redesignTokens";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { Offer } from "../../models/models";

interface OfferIncludedServicesCardProps {
  offer: Partial<Offer>;
}

const ServiceRow: React.FC<{ label: string; included: boolean }> = ({ label, included }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: "5px" }}>
    {included ? (
      <CheckIcon sx={{ fontSize: 18, color: "#27AE60" }} />
    ) : (
      <CloseIcon sx={{ fontSize: 18, color: dt.textMuted }} />
    )}
    <Box
      sx={{
        fontSize: "13px",
        fontFamily: dt.font,
        fontWeight: 500,
        color: included ? dt.textPrimary : dt.textMuted,
      }}
    >
      {label}
    </Box>
  </Box>
);

const OfferIncludedServicesCard: React.FC<OfferIncludedServicesCardProps> = ({ offer }) => {
  const { translate } = useTranslation(["serviceOffers"]);

  return (
    <Box
      sx={{
        backgroundColor: dt.cardBg,
        border: `1px solid ${dt.cardBorder}`,
        borderRadius: dt.radius,
        padding: "20px",
      }}
    >
      <Box
        sx={{
          fontSize: "11px",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "1px",
          color: dt.textMuted,
          fontFamily: dt.font,
          mb: "12px",
        }}
      >
        {translate("includedServices")}
      </Box>

      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: "2px 24px" }}>
        <ServiceRow label={translate("includeDiagnostics")} included={offer.includeDiagnostics || false} />
        <ServiceRow label={translate("includeLaborForRepair")} included={offer.includeLaborForRepair || false} />
        <ServiceRow label={translate("includePartsAndMaterials")} included={offer.includePartsAndMaterials || false} />
        <ServiceRow label={translate("includeTestingAndCalibration")} included={offer.includeTestingAndCalibration || false} />
        <ServiceRow label={translate("includeWorkAreaCleanup")} included={offer.includeWorkAreaCleanup || false} />
        <ServiceRow label={translate("includeDetailedServiceReport")} included={offer.includeDetailedServiceReport || false} />
      </Box>
    </Box>
  );
};

export default OfferIncludedServicesCard;
